'use client';

import React, { useState, useEffect } from 'react';

export default function Version3Popup() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setShowPopup(true);
  }, []);

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
      <div className="relative rounded-2xl px-10 py-8 flex flex-col items-center shadow-2xl" style={{ background: '#1a1b1e', border: '1px solid #2e2f35', minWidth: 280 }}>
        <button
          onClick={() => setShowPopup(false)}
          className="absolute top-3 right-4 text-gray-400 hover:text-white text-xl font-bold leading-none"
          aria-label="Close">

          &times;
        </button>
        <span className="text-white text-2xl font-bold tracking-wide">version 9</span>
      </div>
    </div>);

}